import type { Language, Translation } from './types';

export const dictionary: Record<Language, Translation> = {
  en: {
    appSubtitle: 'Golf rating system',
    createAccount: 'Create Account',
    signIn: 'Sign In',
    register: 'Register',
    home: 'Home',
    rank: 'Rank',
    play: 'Play',
    card: 'Card',
    profile: 'Profile',
    hcpShort: 'HCP',
    settings: 'Settings',
    yourRankMatters: 'YOUR\nRANK\nMATTERS',
    heroCopy: 'Play 1vs1. Track your rating.\nCompete in your club.',
    featuredEvent: 'Featured Event',
    promo: 'Promo',
    joinNow: 'Join now',
    upcoming: 'Upcoming',
    quickAccess: 'Quick Access',
    bookTeeTime: 'Book Tee Time',
    findMatch: 'Find Match',
    findMatchCopy: 'Pick a friend or user to start Emirates Par 3 matchplay.',
    myRating: 'My Rating',
    clubInfo: 'Club Info',
    leaderboard: 'Leaderboard',
    season: 'Season 2026',
    weekly: 'Weekly',
    monthly: 'Monthly',
    allTime: 'All Time',
    challenge: 'Challenge',
    newMatch: 'New\nMatch',
    searchPlayer: 'Search player by name...',
    scanToChallenge: 'Scan to challenge',
    recentOpponents: 'Recent Opponents',
    scoreInput: 'Score\nInput',
    nextHole: 'Next Hole',
    matchResult: 'Match Result',
    challengeRematch: 'Challenge Rematch',
    recentResults: 'Recent Results',
    performance: 'Performance',
    drivingAccuracy: 'Driving Accuracy',
    avgDistance: 'Avg Driving Distance',
    greens: 'Greens in Regulation',
    putts: 'Average Putts / Round',
    myPasses: 'My Passes',
    tournaments: 'Tournaments',
    communities: 'Communities',
    golfClub: 'Golf Club',
    academy: 'Academy',
    partners: 'Partners',
    apply: 'Apply',
    book: 'Book',
    requestLesson: 'Request lesson',
    useOffer: 'I used this offer',
    language: 'Language',
    pushAlerts: 'Push Alerts',
    privacy: 'Privacy',
    subscription: 'Subscription',
    support: 'Support',
    supportEmail: 'support@clubhouse.global',
    signOut: 'Sign Out',
    inviteFriendTitle: 'Invite a friend',
    inviteFriendCopy: 'Send an invitation to install Clubhouse and connect for matchplay.',
    inviteFriendButton: 'Send invite',
    inviteFriendNotFoundTitle: "Can't find them yet?",
    inviteFriendNotFoundCopy: 'Send {name} an invite to install Clubhouse and join your friends list.',
    inviteLinkCopied: 'Invite link copied to clipboard.',
    inviteShareFailed: 'Could not share invite.',
    registerRequiredFields: 'Please fill in all fields.',
    registerPasswordMismatch: 'Passwords do not match.',
    registerPasswordTooShort: 'Password must be at least 8 characters.',
    registerSignInPrompt: 'Already have an account?',
    confirmPassword: 'Confirm password',
    registerInvalidEmail: 'Enter a valid email address.',
    registerCountry: 'Country',
    backToHome: 'Back to home',
    back: 'Back',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    showPassword: 'Show',
    hidePassword: 'Hide',
    seeAll: 'SEE ALL +',
    you: 'You',
    matchesLabel: 'matches',
    free: 'Free',
    membersLabel: 'members',
    handicapShort: 'HCP',
    landingTagline: 'Golf rating, matchplay, and community',
    landingTitle: 'Your rank on the course',
    landingSubtitle:
      'Clubhouse helps golfers track ratings, play matchplay, join communities, and manage their club life in one app.',
    landingFeature1: 'Track your handicap index and matchplay record',
    landingFeature2: 'Challenge friends and climb club leaderboards',
    landingFeature3: 'Book tee times, events, and academy lessons',
    landingFeature4: 'Share your member profile with a QR code',
    ratingLabel: 'RATING',
    welcomeSubtitleNative: 'Track your statistics, book tee times, play tournaments, and join golf communities.',
    welcomeSubtitleWeb: 'Use your Clubhouse account to continue.',
    createAccountTitle: 'Create',
    createAccountHighlight: 'Account',
    registerSubtitle: 'Set up your golf profile',
    fullNameLabel: 'Full name',
    emailFieldLabel: 'Email',
    passwordFieldLabel: 'Password',
    cityFieldLabel: 'City',
    homeClubFieldLabel: 'Home club',
    pillClubs: 'CLUBS',
    pillCommunities: 'COMMUNITIES',
    pillRank: 'RANK',
    pillAcademy: 'ACADEMY',
    pillTournaments: 'TOURNAMENTS',
    tagGolf: 'GOLF',
    detailSoon: 'SOON',
    detailFriendsMatch: 'FRIENDS MATCH',
    detailViewStats: 'VIEW STATS',
    detailCashback: 'CASHBACK',
    detailBookLesson: 'BOOK LESSON',
    detailJoinSelect: 'JOIN / SELECT',
    friendsLabel: 'Friends',
    eventsLabel: 'Events',
    detailAddView: 'ADD / VIEW',
    detailSignups: 'SIGNUPS',
    friendsTitle: 'Friends',
    friendRequests: 'Requests',
    friendPending: 'Pending',
    myFriends: 'My Friends',
    friendsStartMatchSection: 'Friends · Start Match',
    allUsersSection: 'All Users',
    allUsersAddFriendSection: 'All Users · Add Friend',
    noFriendsYet: 'No friends yet.',
    addFriendToMatch: 'Add a friend below to start matchplay.',
    accept: 'Accept',
    remove: 'Remove',
    matchAction: 'Match',
    addAction: 'Add',
    meLabel: 'Me',
    notificationsTitle: 'Inbox',
    loadingNotifications: 'Loading notifications…',
    allCaughtUp: 'You are all caught up.',
    fieldFullName: 'Full Name',
    fieldClub: 'Club',
    fieldCity: 'City',
    fieldCountry: 'Country',
    fieldEmail: 'Email',
    privacyPublic: 'Public',
    privacyFriendsOnly: 'Friends only',
    searchCoursePlaceholder: 'Search course, club, or city',
    recentCourses: 'Recent Courses',
    noCoursesMatch: 'No courses match your search.',
    roundLength: 'Round length',
    tees: 'Tees',
    storeButtonSoon: 'Coming soon',
    appName: 'Club House',
    countryUae: 'UAE',
    countryOman: 'Oman',
    memberLabel: 'Member',
    signInToContinueMatch: 'Sign in to continue your match.',
    noActiveMatchFound: 'No active match found.',
    couldNotLoadMatchHistory: 'Could not load match history.',
    couldNotLoadMatchResult: 'Could not load match result.',
    noActiveMatchToCancel: 'No active match to cancel.',
    cancelMatchTitle: 'Cancel match?',
    cancelMatchBody: 'This will end the unfinished match for both players. No scores or results will be saved.',
    keepPlaying: 'Keep playing',
    cancelMatchAction: 'Cancel match',
    matchCancelled: 'Match cancelled.',
    couldNotCancelMatch: 'Could not cancel match.',
    matchWasCancelled: 'Match was cancelled.',
    activeMatchExistsContinue: 'You already have an active match. Continue scoring.',
    addFriendFirst: 'Add a friend first, then start matchplay.',
    selectOpponentFirst: 'Select an opponent first.',
    courseNotFound: 'Course not found.',
    couldNotStartMatch: 'Could not start match.',
    couldNotLoadProfile: 'Could not load user profile.',
    invalidEmailOrPassword: 'Invalid email or password.',
    couldNotRegisterUser: 'Could not register user.',
    readAll: 'Read all',
    viewAction: 'View',
    friendRequestAccepted: 'Friend request accepted',
    friendRemoved: 'Friend removed',
    friendRequestSent: 'Friend request sent',
    liveMatch: '⛳ Live Match',
    defaultTeeName: 'White',
    matchplayDefault: 'Matchplay',
    opponent: 'Opponent',
    submitted: 'Submitted',
    inProgress: 'In progress',
    finishingMatch: 'Finishing match...',
    waitingOpponentConfirmation: 'Waiting for opponent confirmation',
    confirmYourScorecard: 'Confirm your scorecard',
    waitingOpponentScores: 'Waiting for opponent scores',
    enterScoresProgress: 'Enter scores · {done}/{total} holes',
    confirmScorecardArrow: 'Confirm Scorecard →',
    continueScoringArrow: 'Continue Scoring →',
    cancelMatch: 'Cancel match',
    yourProgress: 'Your progress {done}/{total} holes',
    vsLabel: 'VS',
    activeMatchVs: 'Active match vs {name}',
    tapContinueScoring: 'Tap to continue scoring',
    chooseCourse: 'Choose Course',
    matchHistory: 'Match History',
    matchplaySetup: 'Par 3 Matchplay',
    playerProfile: 'Player Profile',
    defaultScreenTitle: 'Club House',
    filterAll: 'All',
    filterCity: 'City',
    filterCommunity: 'Community',
    filterFriends: 'Friends',
    leaderboardEmpty: 'No players in this ranking yet.',
    pointsShort: 'pts',
    winsLossesShort: 'W/L',
    winsLossesDrawsShort: 'W/L/D',
    handicapIndexShort: 'HI',
    courseHandicapShort: 'CH',
    memberBadge: 'MEMBER',
    courseHandicapAt: 'Course handicap at {course}',
    profileShareTitle: 'Clubhouse profile',
    profileShareMessage: 'My Clubhouse profile ({handle})',
    profileLinkCopied: 'Profile link copied to clipboard.',
    couldNotShareProfile: 'Could not share profile link.',
    fullRound: 'Full round',
    shortRound: 'Short round',
    recentBadge: 'Recent',
    selectedCourse: 'Selected course',
    holesCount: '{count} holes',
    nineHoleHelpTitle: 'Nine-hole courses support 18-hole rounds',
    nineHoleHelpText: 'Select a 9-hole course to choose one round (9 holes) or two rounds (18 holes).',
    matchVsOpponent: 'Match vs {name}',
    pickCourseSubtitle: 'Pick a course for your next matchplay',
    courseHoleCountLabel: '{holes}-hole course',
    nineHolesOption: '9 holes',
    eighteenHolesOption: '18 holes (2 rounds)',
    selectedCourseHint18: 'Score 18 holes by playing {course} twice.',
    selectedCourseHint9: 'Score 9 holes on {course}.',
    matchUsesScorecard: 'This match uses the {holes}-hole scorecard.',
    startHoleMatch: 'Start {holes}-Hole Match',
    twoRoundsSuffix: ' · 2 rounds',
    teesWord: 'tees',
    noActiveMatchStart: 'No active match. Start one from Friends or Play.',
    couldNotSaveHoleScore: 'Could not save hole score.',
    scoresSubmittedWaiting: 'Scores submitted. Waiting for opponent.',
    couldNotSubmitScores: 'Could not submit scores.',
    scorecardConfirmedTitle: 'Scorecard confirmed',
    waitingForConfirmAuto: 'Waiting for {name} to confirm. You will be taken to the match result automatically.',
    couldNotConfirmScorecard: 'Could not confirm scorecard.',
    yourScoreStat: 'YOUR SCORE',
    opponentScoreStat: 'OPPONENT',
    statusStat: 'STATUS',
    holesProgress: 'HOLES PROGRESS ({done}/{total})',
    holeParLabel: '{hole} - PAR {par}',
    holeDistanceLabel: '{distance} {unit}',
    yardsShort: 'yd',
    metersShort: 'm',
    puttsShort: 'Putts',
    addRoundStatistics: 'Add round statistics',
    roundStatisticsHelp: 'Optional details are entered after the match and appear in your Profile.',
    fairwayHit: 'Fairway hit',
    greenInRegulation: 'Green in regulation',
    driveDistance: 'Drive distance (m)',
    penaltiesLabel: 'Penalties',
    saveRoundStatistics: 'Save statistics',
    statisticsSaved: 'Round statistics saved.',
    couldNotSaveStatistics: 'Could not save round statistics.',
    prevButton: 'Prev',
    submitMyScores: 'Submit My Scores',
    saveLastHole: 'Save last hole',
    submittedHolesProgress: 'Submitted · {done}/{total} holes',
    notSubmittedYet: 'Not submitted yet',
    totalScore: 'Total: {score}',
    yourScoresSubmittedWaiting: 'Your scores are submitted. Waiting for {name}.',
    confirmScorecard: 'Confirm Scorecard',
    youConfirmedWaiting: 'You confirmed. Waiting for {name} to confirm.',
    reviewScorecard: 'Review scorecard',
    reviewScorecardTitle: 'Check scores',
    scoreDiscrepancyTitle: 'Score differences',
    pickOfficialScore: 'Choose the correct score',
    youPicked: 'You picked {score}',
    opponentPicked: '{name} picked {score}',
    waitingForAgreement: 'Waiting until you both pick the same number',
    noDiscrepancies: 'No differences. Confirm to finish.',
    fromOpponent: 'From {name}',
    optionalScore: 'Optional',
    couldNotSavePick: 'Could not save your pick.',
    confirmOnlyHint: '{name} already entered both scorecards. Check and confirm.',
    waitingForCoverage: 'Waiting for remaining hole scores',
    pickScoreFor: '{name} · hole {hole}',
    backToHoles: 'Back to holes',
    noCompletedMatch: 'No completed match to display.',
    viewMatchHistory: 'View Match History',
    matchNotFound: 'Match not found.',
    resultWin: 'WIN',
    resultLoss: 'LOSS',
    resultDraw: 'DRAW',
    holesStat: 'HOLES',
    courseStat: 'COURSE',
    resultStat: 'RESULT',
    ratingDeltaStat: 'RATING',
    parStat: 'PAR',
    youStat: 'YOU',
    oppStat: 'OPP',
    couldNotUploadAvatar: 'Could not upload avatar. Try a JPEG, PNG, or WebP image under 5 MB.',
    uploadingPhoto: 'Uploading photo…',
    tapPhotoToChange: 'Tap photo to change',
    photoUpdated: 'Photo updated',
    rankPrefix: 'Rank #',
    premium: 'Premium',
    winRateStat: 'WIN RATE',
    pointsStat: 'POINTS',
    ratingStat: 'RATING',
    ratingChangeStat: 'CHANGE',
    peakRatingStat: 'PEAK',
    provisionalBadge: 'Provisional',
    recordStat: 'W / L / D',
    bestStat: 'BEST',
    noCompletedMatchesYet: 'No completed matches yet.',
    friendJoinRequests: 'Friend Join Requests',
    confirm: 'Confirm',
    decline: 'Decline',
    joinRequestAccepted: 'Join request accepted',
    joinRequestDeclined: 'Join request declined',
    teeTimeBookingSent: 'Tee-time booking request sent',
    lessonRequestSent: 'Lesson request sent',
    cashbackUsageRecorded: 'Cashback usage recorded',
    tournamentApplicationSent: 'Tournament application sent',
    startButton: 'Start',
    communityApplicationSent: 'Community application sent',
    eventSignupSent: 'Event signup sent',
    joinButton: 'Join',
    signUpButton: 'Sign up',
    matchplaySetupTitle: 'Matchplay Setup',
    suggestedCourse: 'Suggested course',
    coursesAfterSignIn: 'Courses will appear after sign in.',
    youWillScoreHoles: 'You will score {holes} holes if you use this course.',
    opponentSection: 'Opponent',
    noFriendSelected: 'No friend selected. Add a friend first.',
    cashbackWord: 'cashback',
    loadingProfile: 'Loading profile…',
    storeDownloadLabel: 'Download the app',
    legalTagline: 'Golf rating & matchplay platform',
    legalTermsLabel: 'Terms',
    legalTermsTitle: 'Terms of Service',
    legalTermsBody:
      'DIGITAL HERO FZCO operates CLUBHOUSE and provides golf matchplay, ratings, and community features. By using the app you agree to fair play, accurate score entry, and respectful conduct toward other members.',
    legalPrivacyLabel: 'Privacy',
    legalPrivacyTitle: 'Privacy Policy',
    legalPrivacyBody:
      'DIGITAL HERO FZCO operates CLUBHOUSE. We store account details, match history, and course activity to operate ratings and matchplay. Data is used to deliver the service and is not sold to third parties.',
    legalCookiesLabel: 'Cookies',
    legalCookiesTitle: 'Cookie Policy',
    legalCookiesBody:
      'DIGITAL HERO FZCO operates CLUBHOUSE. The mobile app uses local session data and standard analytics needed to keep you signed in and improve product performance.',
    inviteShareTitle: 'Join Clubhouse',
    inviteShareMessage: '{name} invited you to join Clubhouse — golf matchplay, ratings, and friends.',
    inviteShareMessageNamed: '{inviter} invited {friend} to join Clubhouse — golf matchplay, ratings, and friends.',
    friendRequestFrom: 'Friend request from {name}',
    clubMember: 'Club member',
    submittingLabel: '…',
    membersCount: 'members',
    signup: 'Sign up',
    scorecardSection: 'SCORECARD',
    pwaInstallTitle: 'Add to Home Screen',
    pwaInstallIntro: 'Install Clubhouse on your device for quick access — no app store required.',
    pwaInstallIosLabel: 'iPhone & iPad (Safari)',
    pwaInstallAndroidLabel: 'Android (Chrome)',
    pwaInstallDesktopLabel: 'Desktop browser',
    pwaInstallIos1: 'Tap the Share button at the bottom of Safari (square with an arrow pointing up).',
    pwaInstallIos2: 'Scroll the menu and tap "Add to Home Screen".',
    pwaInstallIos3: 'Tap "Add" in the top-right corner to confirm.',
    pwaInstallAndroid1: 'Tap the menu button (⋮) in the top-right corner of Chrome.',
    pwaInstallAndroid2: 'Tap "Install app" or "Add to Home screen".',
    pwaInstallAndroid3: 'Confirm when prompted — Clubhouse will appear on your home screen.',
    pwaInstallDesktop1: 'Click the install icon in your browser address bar (or open the browser menu).',
    pwaInstallDesktop2: 'Choose "Install Clubhouse" to pin the app to your desktop or taskbar.',
    appUpdateAvailable: 'A new version is ready',
    appUpdateAction: 'Update',
    serviceUnavailable: 'Clubhouse is updating. Retrying…',
    retryAction: 'Retry',
  },
  ru: {
    appSubtitle: 'Гольф рейтинговая система',
    createAccount: 'Создать аккаунт',
    signIn: 'Войти',
    register: 'Регистрация',
    home: 'Главная',
    rank: 'Рейтинг',
    play: 'Играть',
    card: 'Карта',
    profile: 'Профиль',
    hcpShort: 'HCP',
    settings: 'Настройки',
    yourRankMatters: 'ТВОЙ\nРЕЙТИНГ\nВАЖЕН',
    heroCopy: 'Играй 1 на 1. Следи за рейтингом.\nСоревнуйся в клубе.',
    featuredEvent: 'Главное событие',
    promo: 'Анонс',
    joinNow: 'Участвовать',
    upcoming: 'Ближайшее',
    quickAccess: 'Быстрый доступ',
    bookTeeTime: 'Забронировать ти-тайм',
    findMatch: 'Найти матч',
    findMatchCopy: 'Выберите друга или пользователя для матча Emirates Par 3.',
    myRating: 'Мой рейтинг',
    clubInfo: 'О клубе',
    leaderboard: 'Рейтинг',
    season: 'Сезон 2026',
    weekly: 'Неделя',
    monthly: 'Месяц',
    allTime: 'Все время',
    challenge: 'Вызов',
    newMatch: 'Новый\nматч',
    searchPlayer: 'Поиск игрока...',
    scanToChallenge: 'Сканировать для вызова',
    recentOpponents: 'Недавние соперники',
    scoreInput: 'Ввод\nсчета',
    nextHole: 'Следующая лунка',
    matchResult: 'Результат матча',
    challengeRematch: 'Вызвать на реванш',
    recentResults: 'Последние результаты',
    performance: 'Статистика',
    drivingAccuracy: 'Точность драйва',
    avgDistance: 'Средняя дальность',
    greens: 'Попадания на грин',
    putts: 'Среднее число паттов',
    myPasses: 'Мои пропуска',
    tournaments: 'Турниры',
    communities: 'Сообщества',
    golfClub: 'Гольф-клуб',
    academy: 'Академия',
    partners: 'Партнеры',
    apply: 'Подать заявку',
    book: 'Бронировать',
    requestLesson: 'Записаться',
    useOffer: 'Я использовал оффер',
    language: 'Язык',
    pushAlerts: 'Push уведомления',
    privacy: 'Приватность',
    subscription: 'Подписка',
    support: 'Поддержка',
    supportEmail: 'support@clubhouse.global',
    signOut: 'Выйти',
    inviteFriendTitle: 'Пригласить друга',
    inviteFriendCopy: 'Отправьте приглашение установить Clubhouse и играть вместе.',
    inviteFriendButton: 'Отправить приглашение',
    inviteFriendNotFoundTitle: 'Не нашли в списке?',
    inviteFriendNotFoundCopy: 'Отправьте {name} приглашение установить Clubhouse и добавиться в друзья.',
    inviteLinkCopied: 'Ссылка приглашения скопирована.',
    inviteShareFailed: 'Не удалось отправить приглашение.',
    registerRequiredFields: 'Заполните все поля.',
    registerPasswordMismatch: 'Пароли не совпадают.',
    registerPasswordTooShort: 'Пароль должен быть не короче 8 символов.',
    registerSignInPrompt: 'Уже есть аккаунт?',
    confirmPassword: 'Подтвердите пароль',
    registerInvalidEmail: 'Введите корректный email.',
    registerCountry: 'Страна',
    backToHome: 'На главную',
    back: 'Назад',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Пароль',
    showPassword: 'Показать',
    hidePassword: 'Скрыть',
    seeAll: 'СМОТРЕТЬ ВСЕ +',
    you: 'Вы',
    matchesLabel: 'матчей',
    free: 'Бесплатно',
    membersLabel: 'участников',
    handicapShort: 'HCP',
    landingTagline: 'Гольф рейтинг, матчи и сообщество',
    landingTitle: 'Твой рейтинг на поле',
    landingSubtitle:
      'Clubhouse помогает отслеживать рейтинг, играть матчи, вступать в сообщества и управлять клубной жизнью в одном приложении.',
    landingFeature1: 'Следите за гандикапом и историей матчей',
    landingFeature2: 'Бросайте вызов друзьям и поднимайтесь в рейтинге клуба',
    landingFeature3: 'Бронируйте ти-таймы, события и уроки в академии',
    landingFeature4: 'Делитесь профилем участника через QR-код',
    ratingLabel: 'РЕЙТИНГ',
    welcomeSubtitleNative: 'Следите за статистикой, бронируйте ти-таймы, играйте турниры и вступайте в сообщества.',
    welcomeSubtitleWeb: 'Используйте аккаунт Clubhouse, чтобы продолжить.',
    createAccountTitle: 'Создать',
    createAccountHighlight: 'аккаунт',
    registerSubtitle: 'Настройте свой гольф-профиль',
    fullNameLabel: 'Полное имя',
    emailFieldLabel: 'Email',
    passwordFieldLabel: 'Пароль',
    cityFieldLabel: 'Город',
    homeClubFieldLabel: 'Домашний клуб',
    pillClubs: 'КЛУБЫ',
    pillCommunities: 'СООБЩЕСТВА',
    pillRank: 'РЕЙТИНГ',
    pillAcademy: 'АКАДЕМИЯ',
    pillTournaments: 'ТУРНИРЫ',
    tagGolf: 'ГОЛЬФ',
    detailSoon: 'СКОРО',
    detailFriendsMatch: 'МАТЧ С ДРУГОМ',
    detailViewStats: 'СТАТИСТИКА',
    detailCashback: 'КЭШБЭК',
    detailBookLesson: 'ЗАПИСЬ НА УРОК',
    detailJoinSelect: 'ВСТУПИТЬ / ВЫБРАТЬ',
    friendsLabel: 'Друзья',
    eventsLabel: 'События',
    detailAddView: 'ДОБАВИТЬ / СМОТРЕТЬ',
    detailSignups: 'РЕГИСТРАЦИЯ',
    friendsTitle: 'Друзья',
    friendRequests: 'Заявки',
    friendPending: 'Ожидают',
    myFriends: 'Мои друзья',
    friendsStartMatchSection: 'Друзья · Начать матч',
    allUsersSection: 'Все пользователи',
    allUsersAddFriendSection: 'Все пользователи · Добавить',
    noFriendsYet: 'Пока нет друзей.',
    addFriendToMatch: 'Добавьте друга ниже, чтобы начать матч.',
    accept: 'Принять',
    remove: 'Удалить',
    matchAction: 'Матч',
    addAction: 'Добавить',
    meLabel: 'Я',
    notificationsTitle: 'Лента',
    loadingNotifications: 'Загрузка уведомлений…',
    allCaughtUp: 'Новых уведомлений нет.',
    fieldFullName: 'Полное имя',
    fieldClub: 'Клуб',
    fieldCity: 'Город',
    fieldCountry: 'Страна',
    fieldEmail: 'Email',
    privacyPublic: 'Публичный',
    privacyFriendsOnly: 'Только друзья',
    searchCoursePlaceholder: 'Поиск поля, клуба или города',
    recentCourses: 'Недавние поля',
    noCoursesMatch: 'Нет полей по вашему запросу.',
    roundLength: 'Длина раунда',
    tees: 'Ти',
    storeButtonSoon: 'Скоро',
    appName: 'Club House',
    countryUae: 'ОАЭ',
    countryOman: 'Оман',
    memberLabel: 'Участник',
    signInToContinueMatch: 'Войдите, чтобы продолжить матч.',
    noActiveMatchFound: 'Активный матч не найден.',
    couldNotLoadMatchHistory: 'Не удалось загрузить историю матча.',
    couldNotLoadMatchResult: 'Не удалось загрузить результат матча.',
    noActiveMatchToCancel: 'Нет активного матча для отмены.',
    cancelMatchTitle: 'Отменить матч?',
    cancelMatchBody: 'Незавершённый матч будет отменён для обоих игроков. Счёт и результат не сохранятся.',
    keepPlaying: 'Продолжить игру',
    cancelMatchAction: 'Отменить матч',
    matchCancelled: 'Матч отменён.',
    couldNotCancelMatch: 'Не удалось отменить матч.',
    matchWasCancelled: 'Матч был отменён.',
    activeMatchExistsContinue: 'У вас уже есть активный матч. Продолжите ввод счёта.',
    addFriendFirst: 'Сначала добавьте друга, затем начните матч.',
    selectOpponentFirst: 'Сначала выберите соперника.',
    courseNotFound: 'Поле не найдено.',
    couldNotStartMatch: 'Не удалось начать матч.',
    couldNotLoadProfile: 'Не удалось загрузить профиль.',
    invalidEmailOrPassword: 'Неверный email или пароль.',
    couldNotRegisterUser: 'Не удалось зарегистрировать пользователя.',
    readAll: 'Прочитать все',
    viewAction: 'Открыть',
    friendRequestAccepted: 'Заявка в друзья принята',
    friendRemoved: 'Друг удалён',
    friendRequestSent: 'Заявка в друзья отправлена',
    liveMatch: '⛳ Активный матч',
    defaultTeeName: 'White',
    matchplayDefault: 'Матч',
    opponent: 'Соперник',
    submitted: 'Сдано',
    inProgress: 'В процессе',
    finishingMatch: 'Завершение матча...',
    waitingOpponentConfirmation: 'Ожидание подтверждения соперника',
    confirmYourScorecard: 'Подтвердите карточку счёта',
    waitingOpponentScores: 'Ожидание счёта соперника',
    enterScoresProgress: 'Ввод счёта · {done}/{total} лунок',
    confirmScorecardArrow: 'Подтвердить счёт →',
    continueScoringArrow: 'Продолжить ввод →',
    cancelMatch: 'Отменить матч',
    yourProgress: 'Ваш прогресс {done}/{total} лунок',
    vsLabel: 'VS',
    activeMatchVs: 'Активный матч vs {name}',
    tapContinueScoring: 'Нажмите, чтобы продолжить ввод счёта',
    chooseCourse: 'Выбор поля',
    matchHistory: 'История матча',
    matchplaySetup: 'Матч Par 3',
    playerProfile: 'Профиль игрока',
    defaultScreenTitle: 'Club House',
    filterAll: 'Все',
    filterCity: 'Город',
    filterCommunity: 'Сообщество',
    filterFriends: 'Друзья',
    leaderboardEmpty: 'В этом рейтинге пока нет игроков.',
    pointsShort: 'очк.',
    winsLossesShort: 'В/П',
    winsLossesDrawsShort: 'В/П/Н',
    handicapIndexShort: 'HI',
    courseHandicapShort: 'CH',
    memberBadge: 'УЧАСТНИК',
    courseHandicapAt: 'Курсный гандикап на {course}',
    profileShareTitle: 'Профиль Clubhouse',
    profileShareMessage: 'Мой профиль Clubhouse ({handle})',
    profileLinkCopied: 'Ссылка на профиль скопирована.',
    couldNotShareProfile: 'Не удалось поделиться ссылкой на профиль.',
    fullRound: 'Полный раунд',
    shortRound: 'Короткий раунд',
    recentBadge: 'Недавнее',
    selectedCourse: 'Выбранное поле',
    holesCount: '{count} лунок',
    nineHoleHelpTitle: '9-луночные поля поддерживают 18-луночные раунды',
    nineHoleHelpText: 'Выберите 9-луночное поле для одного раунда (9 лунок) или двух (18 лунок).',
    matchVsOpponent: 'Матч vs {name}',
    pickCourseSubtitle: 'Выберите поле для следующего матча',
    courseHoleCountLabel: 'Поле на {holes} лунок',
    nineHolesOption: '9 лунок',
    eighteenHolesOption: '18 лунок (2 раунда)',
    selectedCourseHint18: '18 лунок — два прохода по {course}.',
    selectedCourseHint9: '9 лунок на {course}.',
    matchUsesScorecard: 'В этом матче используется карточка на {holes} лунок.',
    startHoleMatch: 'Начать матч на {holes} лунок',
    twoRoundsSuffix: ' · 2 раунда',
    teesWord: 'ти',
    noActiveMatchStart: 'Нет активного матча. Начните из раздела «Друзья» или «Играть».',
    couldNotSaveHoleScore: 'Не удалось сохранить счёт лунки.',
    scoresSubmittedWaiting: 'Счёт отправлен. Ожидание соперника.',
    couldNotSubmitScores: 'Не удалось отправить счёт.',
    scorecardConfirmedTitle: 'Карточка подтверждена',
    waitingForConfirmAuto: 'Ожидание подтверждения от {name}. Результат откроется автоматически.',
    couldNotConfirmScorecard: 'Не удалось подтвердить карточку.',
    yourScoreStat: 'ВАШ СЧЁТ',
    opponentScoreStat: 'СОПЕРНИК',
    statusStat: 'СТАУС',
    holesProgress: 'ПРОГРЕСС ({done}/{total})',
    holeParLabel: '{hole} - PAR {par}',
    holeDistanceLabel: '{distance} {unit}',
    yardsShort: 'ярд',
    metersShort: 'м',
    puttsShort: 'Патты',
    addRoundStatistics: 'Добавить статистику раунда',
    roundStatisticsHelp: 'Дополнительные данные вводятся после матча и отображаются в профиле.',
    fairwayHit: 'Попадание на фервей',
    greenInRegulation: 'Грин по регламенту',
    driveDistance: 'Дальность удара (м)',
    penaltiesLabel: 'Штрафы',
    saveRoundStatistics: 'Сохранить статистику',
    statisticsSaved: 'Статистика раунда сохранена.',
    couldNotSaveStatistics: 'Не удалось сохранить статистику раунда.',
    prevButton: 'Назад',
    submitMyScores: 'Отправить мой счёт',
    saveLastHole: 'Сохранить последнюю лунку',
    submittedHolesProgress: 'Сдано · {done}/{total} лунок',
    notSubmittedYet: 'Ещё не сдано',
    totalScore: 'Итого: {score}',
    yourScoresSubmittedWaiting: 'Ваш счёт отправлен. Ожидание {name}.',
    confirmScorecard: 'Подтвердить счёт',
    youConfirmedWaiting: 'Вы подтвердили. Ожидание подтверждения от {name}.',
    reviewScorecard: 'Проверить карточку',
    reviewScorecardTitle: 'Проверка счёта',
    scoreDiscrepancyTitle: 'Расхождения',
    pickOfficialScore: 'Выберите правильный счёт',
    youPicked: 'Вы выбрали {score}',
    opponentPicked: '{name} выбрал {score}',
    waitingForAgreement: 'Ждём, пока оба выберете одно число',
    noDiscrepancies: 'Расхождений нет. Подтвердите, чтобы завершить.',
    fromOpponent: 'От {name}',
    optionalScore: 'Необязательно',
    couldNotSavePick: 'Не удалось сохранить выбор.',
    confirmOnlyHint: '{name} уже ввёл обе карточки. Проверьте и подтвердите.',
    waitingForCoverage: 'Ждём счёт по оставшимся лункам',
    pickScoreFor: '{name} · лунка {hole}',
    backToHoles: 'К лункам',
    noCompletedMatch: 'Нет завершённого матча для отображения.',
    viewMatchHistory: 'История матча',
    matchNotFound: 'Матч не найден.',
    resultWin: 'ПОБЕДА',
    resultLoss: 'ПОРАЖЕНИЕ',
    resultDraw: 'НИЧЬЯ',
    holesStat: 'ЛУНКИ',
    courseStat: 'ПОЛЕ',
    resultStat: 'РЕЗУЛЬТАТ',
    ratingDeltaStat: 'РЕЙТИНГ',
    parStat: 'PAR',
    youStat: 'ВЫ',
    oppStat: 'СОП.',
    couldNotUploadAvatar: 'Не удалось загрузить фото. Используйте JPEG, PNG или WebP до 5 МБ.',
    uploadingPhoto: 'Загрузка фото…',
    tapPhotoToChange: 'Нажмите на фото, чтобы изменить',
    photoUpdated: 'Фото обновлено',
    rankPrefix: 'Место #',
    premium: 'Премиум',
    winRateStat: 'ПОБЕДЫ',
    pointsStat: 'ОЧКИ',
    ratingStat: 'РЕЙТИНГ',
    ratingChangeStat: 'ИЗМЕНЕНИЕ',
    peakRatingStat: 'ПИК',
    provisionalBadge: 'Пробный',
    recordStat: 'В / П / Н',
    bestStat: 'ЛУЧШИЙ',
    noCompletedMatchesYet: 'Завершённых матчей пока нет.',
    friendJoinRequests: 'Заявки друзей на присоединение',
    confirm: 'Подтвердить',
    decline: 'Отклонить',
    joinRequestAccepted: 'Заявка на присоединение принята',
    joinRequestDeclined: 'Заявка на присоединение отклонена',
    teeTimeBookingSent: 'Запрос на бронирование ти-тайма отправлен',
    lessonRequestSent: 'Запрос на урок отправлен',
    cashbackUsageRecorded: 'Использование кэшбэка записано',
    tournamentApplicationSent: 'Заявка на турнир отправлена',
    startButton: 'Начать',
    communityApplicationSent: 'Заявка на вступление отправлена',
    eventSignupSent: 'Регистрация на событие отправлена',
    joinButton: 'Вступить',
    signUpButton: 'Записаться',
    matchplaySetupTitle: 'Настройка матча',
    suggestedCourse: 'Рекомендуемое поле',
    coursesAfterSignIn: 'Поля появятся после входа.',
    youWillScoreHoles: 'Вы будете играть {holes} лунок на этом поле.',
    opponentSection: 'Соперник',
    noFriendSelected: 'Друг не выбран. Сначала добавьте друга.',
    cashbackWord: 'кэшбэк',
    loadingProfile: 'Загрузка профиля…',
    storeDownloadLabel: 'Скачать приложение',
    legalTagline: 'Гольф рейтинг и матчи',
    legalTermsLabel: 'Условия',
    legalTermsTitle: 'Условия использования',
    legalTermsBody:
      'DIGITAL HERO FZCO управляет CLUBHOUSE и предоставляет матчи, рейтинги и функции сообщества. Используя приложение, вы соглашаетесь на честную игру, точный ввод счёта и уважительное отношение к другим участникам.',
    legalPrivacyLabel: 'Конфиденциальность',
    legalPrivacyTitle: 'Политика конфиденциальности',
    legalPrivacyBody:
      'DIGITAL HERO FZCO управляет CLUBHOUSE. Мы храним данные аккаунта, историю матчей и активность на поле для работы рейтингов и матчей. Данные используются для оказания услуги и не продаются третьим лицам.',
    legalCookiesLabel: 'Cookies',
    legalCookiesTitle: 'Политика cookies',
    legalCookiesBody:
      'DIGITAL HERO FZCO управляет CLUBHOUSE. Приложение использует локальные данные сессии и стандартную аналитику для входа и улучшения продукта.',
    inviteShareTitle: 'Присоединяйтесь к Clubhouse',
    inviteShareMessage: '{name} приглашает вас в Clubhouse — матчи, рейтинги и друзья.',
    inviteShareMessageNamed: '{inviter} приглашает {friend} в Clubhouse — матчи, рейтинги и друзья.',
    friendRequestFrom: 'Заявка в друзья от {name}',
    clubMember: 'Участник клуба',
    submittingLabel: '…',
    membersCount: 'участников',
    signup: 'Записаться',
    scorecardSection: 'КАРТОЧКА СЧЁТА',
    pwaInstallTitle: 'Добавить на главный экран',
    pwaInstallIntro: 'Установите Clubhouse на устройство для быстрого доступа — без App Store.',
    pwaInstallIosLabel: 'iPhone и iPad (Safari)',
    pwaInstallAndroidLabel: 'Android (Chrome)',
    pwaInstallDesktopLabel: 'Браузер на компьютере',
    pwaInstallIos1: 'Нажмите «Поделиться» внизу Safari (квадрат со стрелкой вверх).',
    pwaInstallIos2: 'Прокрутите меню и выберите «На экран Домой».',
    pwaInstallIos3: 'Нажмите «Добавить» в правом верхнем углу.',
    pwaInstallAndroid1: 'Нажмите меню (⋮) в правом верхнем углу Chrome.',
    pwaInstallAndroid2: 'Выберите «Установить приложение» или «Добавить на главный экран».',
    pwaInstallAndroid3: 'Подтвердите установку — Clubhouse появится на главном экране.',
    pwaInstallDesktop1: 'Нажмите значок установки в адресной строке браузера (или откройте меню браузера).',
    pwaInstallDesktop2: 'Выберите «Установить Clubhouse», чтобы закрепить приложение на рабочем столе.',
    appUpdateAvailable: 'Доступна новая версия',
    appUpdateAction: 'Обновить',
    serviceUnavailable: 'Clubhouse обновляется. Повторяем попытку…',
    retryAction: 'Повторить',
  },
};
